import Vue from 'vue'
import App from './App.vue'
import router from "./router/index.js" //引入你新建的router文件

import * as echarts from 'echarts'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import'swiper/css/swiper.css'; // 引入 Swiper 样式

//引入公共方法js文件
import publicFun from './util/public'
Vue.config.productionTip = false
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper);
//调用公共方法js文件
Vue.use(publicFun);
// 设置页面标题

let localLang = localStorage.getItem('lang');
let lang = localLang ? localLang : "en"; //实际语言包
// let lang = "en"; //实际语言包

const i18n = new VueI18n({
  locale: lang,
  silentFallbackWarn: true,
  messages: {
    en: {
        ...enLocale,
        ...require("./lang/en.json")
    },
    zh: {
        ...zhLocale,
        ...require("./lang/zh.json")
    },
	zhTw: {
		...enLocale,
		 ...require("./lang/zhTw.json")
	}
  }
});
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI, {i18n: (key, value) => i18n.t(key, value)});

new Vue({
	router,
	i18n,
  render: h => h(App),
}).$mount('#app')
